import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Modal, Upload, message } from 'antd';
import { getCountryCode, newBrand, updateBrand, getBrandDetail, postBrandLogo } from '../../services/brandService';
import { BRAND_LEVEL } from '../../common/constants';
import CategorySelect from '@components/CategorySelect'
const { Option } = Select;
const { TextArea } = Input;

function BrandEdit(props) {
    const { onCancel, visible, brandId } = props;
    const [form] = Form.useForm();
    const [country, setCountry] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [brandIcon, setBrandIcon] = useState();
    const [needUpdate, setNeedUpdate] = useState(false);
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 },
        },
    };

    useEffect(() => {
        getCountryCode().then(res => {
            setCountry(Object.entries(res.data.countryCodes));
        });
    }, []);

    useEffect(() => {
        form.resetFields();
        setBrandIcon(null);
        updateBrandInfo(brandId);
    }, [brandId])

    useEffect(() => {
        if(needUpdate) {
            setNeedUpdate(false);
            if(brandId) {
                updateBrandInfo(brandId);
            } else {
                form.resetFields();
            }
        }
    }, [needUpdate])

    function updateBrandInfo(id) {
        if(id) {
            getBrandDetail(id).then(res => {
                form.setFieldsValue(res.data);
                setBrandIcon(res.data.icon);
            })
        }
    }

    function uploadImage(data) {
        const file = data.file;
        let format = file.type.split('/')[1]
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (evt) {
          // 创建image对象
          let image = new Image();
          image.src = evt.target.result;
          // 获取图片宽高
          image.onload = function () {
            let formData = new FormData();
            formData.append('format', format)
            formData.append('input', file)
            postBrandLogo(formData)
            .then(res => {
              setBrandIcon(res.data);
            })
            .catch(err => {
            })
          }
        };
      }

    function handleSubmit() {
        form.validateFields().then((values) => {
            if(!submitting) {
                setSubmitting(true);
                const data = {
                    ...values,
                    icon: brandIcon,
                    descriptions: values?.descriptions?.length ? values?.descriptions?.filter(e => !!e) : []
                }
                if(!brandIcon) {
                    delete data.icon;
                }
                submit(data, brandId).then(res => {
                    setSubmitting(false);
                    message.success('保存成功');
                    setNeedUpdate(true);
                    setBrandIcon(null);
                    props.saveSuccess && props.saveSuccess();
                }).catch(error => {
                    setSubmitting(false);
                    const response = (error.response && error.response.data) || error;
                    message.error(response?.messages?.[0] || '保存失败');
                });
            }
        })
    }

    function submit(data, id) {
        if(id) {
            return updateBrand(id, data);
        } else {
            return newBrand(data);
        }
    }

    return (
        <Modal
            visible={visible}
            okText="提交"
            cancelText="取消"
            onCancel={onCancel}
            onOk={handleSubmit}
            destroyOnClose={true}
            confirmLoading={submitting}
        >
            <Form {...formItemLayout} name='brand-edit-modal' form={form}>
                <Form.Item label="管理品牌" name="name" rules={[{ required: true, message: '请输入管理品牌名' }]}>
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="管理品牌中文名" name="nameCN">
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="品牌别名" name="alias">
                    <Select
                        mode="tags"
                        placeholder="请输入别名，以逗号分隔"
                        tokenSeparators={['，', ',']}
                    ></Select>
                </Form.Item>
                <Form.Item label="商家品牌名" name="otherNames">
                    <Select
                        mode="tags"
                        placeholder="请输入商家品牌名，以逗号分隔"
                        tokenSeparators={['，', ',']}
                    ></Select>
                </Form.Item>
                <Form.Item label="搜索重写词" name="searchRewriteTerms">
                    <Select
                        mode="tags"
                        placeholder="请输入搜索重写词，以逗号分隔"
                        tokenSeparators={['，', ',']}
                    ></Select>
                </Form.Item>
                <Form.Item label="app内展示名称" name="displayName">
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="归属国家/地区" name="countryCode">
                    <Select allowClear>
                        {country.map((item) => {
                            const [key, value] = item;
                            return (
                                <Option key={value} value={value}>{key}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
                <Form.Item label="等级" name="level">
                    <Select allowClear>
                        {BRAND_LEVEL.map((item) => {
                            return (
                                <Option key={item.id} value={item.id}>{item.label}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
                <Form.Item label="关联类目" name="associatedCategory">
                    <CategorySelect disabledNode={[1, 3]} />
                </Form.Item>
                <Form.Item label="logo" name="icon" initialValue={brandIcon}>
                    <Upload
                        name="icon"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        customRequest={uploadImage}
                    >
                        {brandIcon?.full?.url ?
                            <img
                                src={brandIcon?.full?.url}
                                alt="avatar"
                                style={{ width: '100%' }}
                            /> : 
                            <div>
                                上传图片<br />
                                400*400
                            </div>
                        }
                    </Upload>
                </Form.Item>
                <Form.Item label="简介" name={['descriptions', 0]}>
                    <TextArea
                        allowClear 
                        placeholder="请输入简介"
                        autoSize={{minRows: 5}}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default BrandEdit;